import type { TaxonomyTerm } from '../../hooks/useTaxonomyTerms';

/**
 * Filter subcategory terms to only those whose allowedExtensions include the
 * file's extension. If a term has no allowedExtensions (field not set), it is
 * included as a fallback so users can always assign a category.
 */
export function filterCategoriesForFile(
  file: File,
  allCategories: TaxonomyTerm[],
): TaxonomyTerm[] {
  const ext = file.name.split('.').pop()?.toLowerCase() ?? '';
  if (!ext) return allCategories;

  return allCategories.filter(
    (term) => !term.allowedExtensions || term.allowedExtensions.includes(ext),
  );
}
